import { Auth } from "aws-amplify";
import { cognitoConfig } from 'config';
import {fromCognitoIdentityPool} from "@aws-sdk/credential-providers";
import { S3Client, GetObjectCommand } from '@aws-sdk/client-s3';
import { getSignedUrl } from '@aws-sdk/s3-request-presigner';
import { retryMiddleware } from "@smithy/middleware-retry";

  export const getS3Client = async () => {
    const token = (await Auth.currentSession()).getIdToken().getJwtToken()
    const COGNITO_ID = `cognito-idp.${cognitoConfig.aws_cognito_region}.amazonaws.com/${cognitoConfig.aws_user_pools_id}`
    const s3Configuration = {
        credentials: fromCognitoIdentityPool({
            clientConfig: { region: cognitoConfig.aws_cognito_region }, // Configure the underlying CognitoIdentityClient.
            identityPoolId: cognitoConfig.identity_pool_id,
            logins: {
                [COGNITO_ID]: token,
                },
          }),
        region: cognitoConfig.aws_cognito_region 
    };

    return new S3Client(s3Configuration);

}